<template>
  <div class="wrapper hefei-bg-f5" id="j-list">
    <div class="toggle-container inquiryOrder-tab">
        <div class="item-wrap s-item-wrap" :class="{'active':param.status == ''}" @click="tabChange('')">全部</div>
        <!-- <div class="item-wrap s-item-wrap" v-if="userType=='01'" :class="{'active':param.status == '00'}" @click="tabChange('00')">待支付</div> -->
        <div class="item-wrap s-item-wrap" :class="{'active':param.status == '01,02'}" @click="tabChange('01,02')">待回复</div>
        <div class="item-wrap s-item-wrap" :class="{'active':param.status == '03,99'}" @click="tabChange('03,99')">回复中</div>
        <div class="item-wrap s-item-wrap" :class="{'active':param.status == '04,08'}" @click="tabChange('04,08')">已完成</div>
        <div class="item-wrap s-item-wrap" :class="{'active':param.status == '05,06,07'}" @click="tabChange('05,06,07,10')">已取消</div>
    </div>
    <div class="swiper-container j-container">
        <div class="swiper-wrapper" v-if="consultList.length>0">
            <div class="inquiryOrder-wrap2 swiper-slide" :class="{'patient':userType == '01'}">
                <div class="order-item-wrap" v-for="(item, index) in consultList" :key="index">
                    <div @click="linkGo(item)">
                      <div class="order-title">
                          <h2>
                            <div class="img-wrap" v-if="userType=='03'">
                              <img src="../../assets/images/avatar_male.png">
                              <!-- <img v-if="item.userSex==1" src="../../assets/images/avatar_male.png">
                              <img v-if="item.userSex==2" src="../../assets/images/avatar_female.png"> -->
                            </div>
                            <div class="img-wrap" v-if="userType=='01'"><img :src="doctorImgError" @error="doctorImgError"></div>
                            <span class="title-name">{{consultTypeObj1[item.consultType]}}</span>
                            <span>[{{consultTypeObj2[item.consultType]}}]</span>
                          </h2>
                          <span class="orange" v-if="item.status=='00'">待支付</span>
                          <span class="orange" v-if="item.status=='01' || item.status=='02'">待回复</span>
                          <span class="green" v-if="item.status=='03'">回复中</span>
                          <span v-if="item.status=='04' || item.status=='08'">已完成</span>
                          <span v-if="item.status=='05' || item.status=='06' || item.status=='07' || item.status=='10'">已取消</span>
                          <span v-if="item.status=='09'">未支付过期</span>
                          <!-- <span v-if="item.status=='10'">已关闭</span> -->
                          <span v-if="item.status=='99'">免费咨询</span>
                      </div>
                      <div class="order-content">
                          <div class="text-wrap">
                              <div class="line1">
                                  <h2 class="fn-fl" v-if="userType=='01'">{{item.doctorName}} <span>{{item.doctorTitle}}</span></h2>
                                  <h2 class="fn-fl" v-if="userType=='03'">{{item.userName}} <span>{{item.userSex==1?'男':'女'}} {{item.userAge}}岁</span></h2>
                                  <h2 class="fn-fr">
                                    ¥{{item.consultPrice}}
                                    <span class="orange" v-if="item.status=='05'">(退款中)</span>
                                    <span class="green" v-if="item.status=='06'">(退款成功)</span>
                                  </h2>
                              </div>
                              <div class="line2" v-if="userType=='01'">{{item.hospitalName}} | {{item.deptName}}</div>
                              <div class="line3">病情：{{item.symptomDesc}}</div>
                              <div class="line4">{{item.createTime | dateFormat}}</div>
                          </div>
                      </div>
                    </div>
                    <div class="order-btn" v-if="userType=='01' && (item.status=='00' || item.status=='01' || item.status=='02')">
                      <a class="btn cancel" @click="cancelOrder(item)" v-if="item.status=='00'">取消</a>
                      <a class="btn confirm" @click="goPay(item)" v-if="item.status=='00'">付款</a>
                      <a class="btn cancel" @click="cancelOrder(item)" v-if="item.status=='01' || item.status=='02'">取消咨询</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="empty-wrap" v-else>
          <img src="../../assets/images/icon-empty-pic.png" alt="">
          <p>暂无数据</p>
        </div>
    </div>
  </div>
</template>
<script>
import { MessageBox } from 'mint-ui';

import * as $services from '@/services/index'
export default {
  filters: {
    dateFormat(date) {
      return date.substring(0,4)+"/"+date.substring(4,6)+"/"+date.substring(6,8)+"/ "+date.substring(8,10)+":"+date.substring(10,12)+":"+date.substring(12,14)
    }
  },
  data() {
    return {
      load:false,
      noDate:false,
      consultList:[],
      userType:"03",
      param:{
        status:"01,02,03,04,05"
      },
      pageParam:{
        pageNo:1,
        rows:15
      },
      isMini:false,
      consultTypeObj1:{
        "01":"在线咨询",
        "02":"在线咨询",
        "03":"在线复诊",
        "04":"在线复诊",
        "05":"免费咨询",
        "06":"续方申请"
      },
      consultTypeObj2:{
        "01":"图文",
        "02":"视频",
        "03":"图文",
        "04":"视频",
        "05":"图文",
        "06":"图文"
      }
    };
  },
  // components: {
  // },
  created() {
    this.isMini = this.$store.getters.platform === 'mp'? true : false;
    this.userType = this.$route.query.userType;
    this.param.status = this.$route.query.status || "";
    this.getConsultList();
  },
  mounted() {
    const ua = window.navigator.userAgent.toLowerCase();
    this.loadMore();
  },
  methods: {
    getConsultList(){
      $services.getConsultList(this.param,this.pageParam).then(res => {
        this.load = false;
        this.noDate = !res || res.length == 0?true:false;
        this.consultList = res && this.consultList.concat(res) || [];
      }).catch(function (err) {
        console.log(err);
      });
    },
    tabChange(status){
      this.consultList = [];
      this.param.status = status;
      this.pageParam.pageNo = 1;
      this.noDate = false;
      this.getConsultList();
    },
    loadMore () {
        let dom = document.getElementById('j-list');
        dom.onscroll = () => {
            var _winH = window.innerHeight,
                _docH = document.querySelector(".j-container").offsetHeight,
                _scrollTop = dom.scrollTop;
            var _wSheight = _winH + _scrollTop;
            if ((_docH - _wSheight) < 20) {
              if (!this.load && !this.noDate) {
                  this.load = true;
                  this.pageParam.pageNo++;
                  this.getConsultList();
              }
            }
        }
    },
    linkGo(item){
      if(item.status == "01" || item.status == "02" || item.status == "03" || item.status == "04" || item.status == "08" || item.status == "99"){
        if (this.isMini === true) {
          wx.miniProgram.navigateTo({
            url: "/pages/imChat/main?userType="+ this.userType +"&orderNo=" + item.id
          });
        }else{
          this.$router.push({ path: "/imChat", query: {userType:this.userType,orderNo:item.id}});
        }
      }else{
        this.$router.push({ path: "/recordInfo", query: {userType:this.userType,orderNo:item.id}});
      }
    },
    goPay(item){
      var queryData = {
        money: item.consultPrice,
        consultType: item.consultType,
        orderNo: item.id,
        type: 1
      }
      if (this.isMini === true) {
        queryData.payType = "03";
        queryData.sessionId = this.$store.getters.token;
        wx.miniProgram.navigateTo({
          url: "/pages/cashier/main?urlParam="+JSON.stringify(queryData)
        });
      }else{
        this.$router.push({ path: "/payment", query:queryData });
      }
    },
    doctorImgError(e){
      e.target.src = require("../../assets/images/default_male.png");
    },
    cancelOrder(item){
      MessageBox.confirm('是否确认取消该订单?').then(action => {
          $services.sendInstructions({
            instructionsCode:"301002",
            doctorId:item.doctorId,
            url:""
          }).then(res => {
            this.consultList = [];
            this.pageParam.pageNo = 1;
            this.noDate = false;
            this.getConsultList();
          }).catch(err => {
            console.log(err);
          });
      }).catch(err => {
        console.log(err);
      });

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/recordList.vue